/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLast_settings = {
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_settings" | "ReplyListContainerLastFlattened_settings">;
    readonly " $refType": "ReplyListContainerLast_settings";
};
export type ReplyListContainerLast_settings$data = ReplyListContainerLast_settings;
export type ReplyListContainerLast_settings$key = {
    readonly " $data"?: ReplyListContainerLast_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLast_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "flattenReplies"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLast_settings",
    "selections": [
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LocalReplyListContainer_settings"
                }
            ]
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReplyListContainerLastFlattened_settings"
                }
            ]
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c578f8bac7d8c231f2462a7a7cfdd90f';
export default node;
